import * as dependencies from './dependencies';

Object.entries(dependencies).map(e => {
	window[e[0]] = e[1]
})